/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
    SHOW_LOADER,
    HIDE_LOADER,
    SHOW_HIDE_USER_LOADER,
    SHOW_HIDE_ROLE_ASSIGNMENT_LOADER,
    SHOW_HIDE_BUILT_IN_POLICIES_LOADER
} from "./types";

export const showLoaderAction = () => {
    return {
       type: SHOW_LOADER,
       displayLoader: true
        };
};

export const hideLoaderAction = () => {
    return {
      type: HIDE_LOADER,
      displayLoader: false
    };
  };
export const showHideUserLoaderAction=(showHideUserLoader:boolean)=>{
 return {
   type:SHOW_HIDE_USER_LOADER,
   showHideUserLoader
 }
}
export const showHideRoleAssignmentLoaderAction=(showHideRoleAssignmentLoader:boolean)=>{
  return {
    type:SHOW_HIDE_ROLE_ASSIGNMENT_LOADER,
    showHideRoleAssignmentLoader
  }
 
 }
export const showHideBuiltinPoliciesLoaderAction = ( showHideBuiltinPoliciesLoader : boolean )=> {
    return {
        type:SHOW_HIDE_BUILT_IN_POLICIES_LOADER,
        showHideBuiltinPoliciesLoader
    }
}